import React from 'react';
import URL from '@core/scripts/helper/url';

export default function ReviewRating({rating, ratingClass}) {
    return (
        <div className="reviews__rating">
            <div
                className="reviews__rating-stars reviews__rating-stars--full"
                style={{width: `calc((${rating}/5)*100%)`}}
            >
                {getStars('full', ratingClass)}
            </div>
            <div className="reviews__rating-stars">{getStars('empty', ratingClass)}</div>
        </div>
    );
}

function getStars(type, ratingClass) {
    const stars = [];
    for (let i = 0; i < 5; i++) {
        stars.push(
            <img
                key={i}
                loading="lazy"
                width={10}
                height={10}
                className={ratingClass + ' lazyload'}
                data-src={URL.toStaticResourcesRoot(`/images/rating/rating_${type}.svg`)}
            />
        );
    }
    return stars;
}
